import { useState } from "react";
import Loading from "../Loading";

const OperationTourOps = () => {
    const [loading, setLoading] = useState(true);

    const hideSpinner = () => {
        setLoading(false);
    };

    return (
        <>
            {loading && <Loading />}
            <iframe title="Operation tour-ops"
                src={`${process.env.REACT_APP_OPERATION_TOUR_OPS_URL}`}
                onLoad={hideSpinner}
                hidden={loading ? true : false}
                allow="local-network-access"
            >
            </iframe>
        </>
    )
}

export default OperationTourOps;
